import { SegmentedControl, SegmentedControlItem } from '@mantine/core';
import React, { FC } from 'react';

import { useDesignField } from './hooks';

interface SegmentedControlFieldProps {
  valuePath: Array<string>;
  options: Array<SegmentedControlItem>;
}

export const SegmentedControlField: FC<SegmentedControlFieldProps> = ({
  valuePath,
  options,
}) => {
  const { value, onChange } = useDesignField(valuePath);

  return <SegmentedControl value={value} data={options} onChange={onChange} />;
};
